import { Config, Socials, TokenHistoryLabel } from "kadow-jetpack-model";

import { cleanSocialLinksByCTA } from "./cleanSocialLinksByCTA";

export function cleanSocialLinks(config: Config): Config | null {
  if (!config || !config.socials) return config;

  Object.keys(config.socials).forEach((key) => {
    if (!config.socials[key as keyof Socials]) {
      return config;
    } else {
      const socialKey = key as TokenHistoryLabel;
      // @ts-ignore
      config.socials[socialKey] = cleanSocialLinksByCTA(
        socialKey,
        // @ts-ignore
        config.socials[socialKey] as string
      );
    }
  });
  return config;
}
